import * as React from "react"

import { cn } from '@/utils/cn'

export const fieldControlInteractionClasses =
  "transition-[background-color,color,border-color,box-shadow] duration-150 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50"

export const fieldControlClasses =
  "flex h-touch-sm w-full rounded-md border border-input bg-background px-3 py-2 text-base shadow-sm md:text-sm"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          fieldControlClasses,
          fieldControlInteractionClasses,
          "sm:h-10",
          "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
